<template>
    <div>
        <el-card shadow="hover">
            <div slot="header" class="px-1">
                <h6 class="text-center m-0">{{ cardtitle }}</h6>
            </div>
            <div class="text-center mb-2">
                <el-radio-group size="small" v-model="charttype">
                    <el-radio :label="'piechart'">Piechart</el-radio>
                    <el-radio :label="'barchart'">Barchart</el-radio>
                </el-radio-group>
                <el-checkbox v-if="charttype=='barchart'" v-model="stacked" class="ml-3">Stacked</el-checkbox>
            </div>
            <PieChart class="mt-4" :data="this.chartdata" :url="''" v-if="charttype=='piechart'"  style="width:100%;"/>
            <BarChart v-loading.body="loading.chart" :data="barchart" :width="500" :height="330" v-if="charttype=='barchart'" />
            <Loader v-if="loading.chart" />
        </el-card>
    </div>
</template>

<script>
import Treasury from '@/components/page/Treasury.js'
import PieChart from '@/components/chart/Pie.js'
//import PieChart from '@/components/chart/Doughnut.js'
import BarChart from '@/components/chart/BarChart.js'
import { Rainbow, Rainbow3, Penanggalan, AppColors, Config, AxiosWithJar } from '@/utility.js'
import Loader from '@/components/loader/Loader2.vue'

export default {
    extends: Treasury,
    components:{
        PieChart,
        Loader,
        BarChart,
     },
    props: {
        title: {
            type: String,
            default: 'PIECHART',
            //required: false,
        },
        area: {
            type: String,
            default: '',
            //required: false,
        },
        status :{
            type: String,
            default: '',
            //required: false,
        },
        charttypedefault :{
            type: String,
            default: 'piechart',
            //required: false,
        },
    },
    setup() {

    },
    mounted() {
        //this.setCashNonCashData()
        this.getData()
    },
    data() {
        return {
            cardtitle: this.title, //'STATUS BY SALES AREA',
            charttype: this.charttypedefault, //'piechart',
            stacked: false,
            chartdata: [],
            maindata: [],
            barchart: [],
            loading : {
                table: true,
                chart: true,
            }
        }
    },
    watch : {
        stacked() {
            this.setBarchart();
        }
    },
    methods: {
        async getData() {
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/v1/dooutstanding/piechartstatusbysalesarea?'

			//this.urlRequestParams+='&date-range-start='+ (this.dateRange && this.dateRange[0] ? this.dateRange[0] : '')
			//this.urlRequestParams+='&date-range-end='+ (this.dateRange && this.dateRange[1] ? this.dateRange[1] : '')
			this.urlRequestParams+='&status='+this.status
			//this.urlRequestParams+='&area='+this.area
			this.urlRequestParams+='&region=region'

			this.loading.table = true;
			this.loading.chart = true;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					let balanceData = response.data.data.data;
                    this.maindata = response.data.data.data;
					//this.title = response.data.data.title.toUpperCase();
                    this.setPiecharthData(balanceData)
                    //console.log(JSON.stringify(balanceData));
                    this.setBarchart();
                })
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.chart = false;
					this.loading.table = false;
				})

        },

        setPiecharthData(data) {
			let item = data //CashPosition;
			//console.log('item pieChartData:' + JSON.stringify(item))
            var warna = []

            let value = [];
            let idx = 0;
            for (var row in item) {
                //add color
                warna[item[row].Label] = AppColors[idx];//'#FFB22E'

                //add value
                let main = {
                    transtype: item[row].Label,
                    amount: item[row].Nilai,
                };

                value.push(main);
                idx++;
            }

            this.chartdata = this.processPieChart(value, "amount", "transtype", 1, 2, warna);
        },

        setBarchart() {
            this.barchart = this.processBarChart(this.maindata, 'Label', '', 'Nilai', false, 'Grup', "", 1, 2, AppColors, false, false, false, this.stacked);
        },
    }
}
</script>

<style>
.el-card__header {
    padding: 12px 10px;
}
</style>
